export enum CostingLevelTypeEnum {
    DIRECT_MATERIAL_COST = 'DIRECT_MATERIAL_COST',
    DIRECT_PRODUCTION_COST = 'DIRECT_PRODUCTION_COST',
    INDIRECT_MATERIAL_COST = 'INDIRECT_MATERIAL_COST',
    INDIRECT_PRODUCTION_COST = 'INDIRECT_PRODUCTION_COST',
    INDIRECT_DISTRIBUTION_COST = 'INDIRECT_DISTRIBUTION_COST',
    INDIRECT_ADMINISTRATION_COST = 'INDIRECT_ADMINISTRATION_COST',
}
